<template>
  <div class="menuBody" >
    <div class="menuTool" style="width:100%;">
        <pollingTree @pollingTree="getMsgFormSon" />
         <PollingRecordDialog  ref="PollingRecordDialog"/>
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                巡检记录列表
              <!-- <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="PropertyAdd()">巡检任务添加</el-button>
            </div> -->
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                <el-select  clearable v-model="value" size="small" @change="classificationChange(value)" placeholder="请选择巡检分类">
                    <el-option
                    v-for="item in classificationList"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id">
                    </el-option>
                </el-select>
              </div>
              <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入点位名称" size="small"    v-model="spotName"></el-input>
              </div>
              <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入巡检人员" size="small"    v-model="staff"></el-input>
              </div>
              <div style="width:150px;float:left;margin-right:15px">
                    <el-date-picker
                        v-model="value1"
                        type="daterange"
                        size="small"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="TimeChange(value1)">
                    </el-date-picker>
              </div>
            <div style="float:right;margin-right:15px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"   v-loading="loading"  style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="projectName" label="所属项目"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="filedName"   label="巡检分类"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotName"    label="点位名称" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotCode"    label="点位编码" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="insSystem"   label="所属系统" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="location"    label="地址"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="staff"       label="巡检人员"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="source"   label="巡查岗位" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="createDateTime"   label="巡查时间" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotInsStatus"   label="点位状态" >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.spotInsStatus=='0'" >待巡检</el-tag>
            <el-tag v-if="scope.row.spotInsStatus=='2'" >已完成</el-tag>
            <el-tag v-if="scope.row.spotInsStatus=='5'" >有异常</el-tag>
            <el-tag v-if="scope.row.spotInsStatus=='6'" >已办理</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectResult"   label="巡检结果" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="exOrder"   label="异常工单号" ></el-table-column>
        <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
            <el-button @click="examine(scope.row)" type="primary" icon="el-icon-view" circle size="small" title="查看"></el-button>
            </template>
        </el-table-column>
    </el-table> 
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import PollingRecordDialog from '../pollingCommon/PollingRecordDialog.vue'
import pollingTree from "../pollingCommon/pollingTree.vue";
export default {
  name: "PollingRecord",
  components: {PollingRecordDialog,pollingTree},
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        loading:false,
        classifyName:"",
        tableData:[],
        classificationList:[{
            "value":"1",
            "label":"工程巡检"
        }],
        value:"",
        InodeCode:"",
        orgId:"",
        value1:"",
        spotName:"",
        staff:"",
        startDate:"",
        endDate:"",

    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.InitialQuery()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.InitialQuery()
    },
    InitialQuery(){
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "filedName":"",
        "spotName":"",
        "staff":"",
        "startDate":"",
        "endDate":"",
        "orgId":this.orgId,
      }
    this.$http.post(this.$requestUrl.POST_LOG_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        for(let val of data.data.records){
          val.createDate=val.createDate.replace('T',' ')
          val.createDateTime = val.createDate.substr(0,val.createDate.length-9)
        }
        // console.log(data.data.records)
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    PropertyAdd(){
    // 添加
    },
    examine(row){
    // 查看
    // console.log(row)
        let arr = row.exImgUrl.split(';')
        this.$refs.PollingRecordDialog.value = row.projectName
        this.$refs.PollingRecordDialog.title = "记录详情";
        this.$refs.PollingRecordDialog.dialogVisible = true;
        this.$refs.PollingRecordDialog.formLabelAlign = row 
        this.$refs.PollingRecordDialog.ClassifyNameList = this.SubordinateList
        this.$refs.PollingRecordDialog.url = arr[0]
        this.$refs.PollingRecordDialog.srcList = arr
    },
    delMenu(row){
    // 删除
    },
    Inquire(){
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "filedName":this.inspectTypeName,
        "spotName":this.spotName,
        "staff":this.staff,
        "startDate":this.startDate,
        "endDate":this.endDate,
        "orgId":this.orgId,
      }
      this.$http.post(this.$requestUrl.POST_LOG_LIST,PageSize).then((res) => {
        let data = res.data
        if(data.code == 200){
          for(let val of data.data.records){
            val.createDate = val.createDate.replace('T',' ')
            val.createDateTime = val.createDate.substr(0,val.createDate.length-9)
          }
          this.tableData = data.data.records
          this.total = data.data.total
        }else{
          this.$message.error(data.msg)
        }
      }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    classificationChange(res){
    for(let val of this.classificationList){
        if(val.id == res){
          this.inspectTypeName = val.typeName
        }
      }
    },
    TimeChange(date){
      this.getDate(date)
    },
    getDate(res){
	    	let date = res[0];
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let time = year+"-"+month+"-"+dates
        this.startDate = time
        let datea = res[1];
	    	let yeara = datea.getFullYear();
	    	let montha = datea.getMonth() + 1 < 10 ? '0' + (datea.getMonth() + 1 ): datea.getMonth() + 1
	    	let datesa = datea.getDate()< 10 ? '0' +datea.getDate() : datea.getDate()
        let timea = yeara+"-"+montha+"-"+datesa
        this.endDate = timea
	    },
    getMsgFormSon(data){
              if(data.orgId == null){
        this.orgId = data.id
      }else{
        this.orgId = data.orgId
      }
        this.InitialQuery()
    },
    getUserOffice() {
      this.$http.get("/inspect/project/list").then((res) => {
          if(res.data.code == 200){
            this.ClassifyNameList = res.data.data
          }else{
            this.$message.error(res.data.msg)
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    classification(){
      this.$http.get("/inspect/type/select").then((res)=>{
      let data = res.data
      if(data.code == 200){
        this.classificationList = res.data.data
      }else{
         this.$message.error(data.msg)
      }
      })
    },
  },
  mounted() {
    this.getUserOffice()
    this.classification()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>